import { Plus, Trash2 } from "lucide-react";

const LABELS = {
  settings: "Settings (email & booking links)",
  contact_email: "Contact email (receives form messages)",
  calendly_consult_url: "Calendly link — free 20-minute phone consult",
  calendly_session_url: "Calendly link — 50-minute session",
  calendly_couples_url: "Calendly link — 60-minute couples session",
  q: "Question",
  a: "Answer",
  offered: "Services offered (Home cards + service pages)",
  slug: "Page address (after /services/)",
  intro: "Intro (optional)",
  areas: "Areas of support",
  session_format: "Session details box text (optional, overrides the default)",
  services_title: "Services offered title",
  services_more: "Service card link text",
};

const blank = (v) =>
  typeof v === "string" ? "" : Array.isArray(v) ? [] : Object.fromEntries(Object.entries(v).map(([k, x]) => [k, blank(x)]));

const human = (k) => LABELS[k] || k.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
const slug = (path) => path.join("-").replace(/[^a-z0-9-]/gi, "-").toLowerCase();

const TextField = ({ path, value, onChange }) => {
  const long = value.length > 90 || value.includes("\n");
  const id = `field-${slug(path)}`;
  const cls = "mt-1.5 w-full rounded-lg border border-[#B9A9D8]/70 bg-white px-3 py-2 text-[15px] text-[#22304A] focus:border-[#6F5B9E]";
  return (
    <div>
      <label htmlFor={id} className="text-sm font-medium text-[#22304A]">{human(path[path.length - 1])}</label>
      {long ? (
        <textarea id={id} rows={Math.min(14, Math.max(3, Math.ceil(value.length / 90) + (value.match(/\n/g) || []).length))} value={value} onChange={(e) => onChange(e.target.value)} className={cls} data-testid={id} />
      ) : (
        <input id={id} value={value} onChange={(e) => onChange(e.target.value)} className={cls} data-testid={id} />
      )}
    </div>
  );
};

const ListField = ({ path, value, onChange }) => {
  const template = blank(value[0] ?? { title: "" });
  return (
    <fieldset className="space-y-3">
      <legend className="mb-2 text-sm font-medium text-[#22304A]">{human(path[path.length - 1])}</legend>
      {value.map((item, i) => (
        <div key={i} className="relative rounded-xl border border-[#B9A9D8]/40 bg-[#FAF8F4] p-4 pr-12">
          <Editor path={[...path, String(i)]} value={item} onChange={(v) => onChange(value.map((x, j) => (j === i ? v : x)))} />
          <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} aria-label="Remove item" className="absolute right-3 top-3 rounded-full p-1.5 text-[#6B7280] hover:bg-[#991B1B]/10 hover:text-[#991B1B]" data-testid={`remove-${slug(path)}-${i}`}>
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...value, template])} className="inline-flex items-center gap-1.5 text-sm text-[#6F5B9E] hover:underline" data-testid={`add-${slug(path)}`}>
        <Plus className="h-4 w-4" /> Add item
      </button>
    </fieldset>
  );
};

export const Editor = ({ path, value, onChange }) => {
  if (typeof value === "string") return <TextField path={path} value={value} onChange={onChange} />;
  if (Array.isArray(value)) return <ListField path={path} value={value} onChange={onChange} />;
  return (
    <div className="space-y-4">
      {Object.entries(value).map(([k, v]) => (
        <Editor key={k} path={[...path, k]} value={v} onChange={(nv) => onChange({ ...value, [k]: nv })} />
      ))}
    </div>
  );
};

export const sectionLabel = human;
